import { inject, Injectable } from '@angular/core';
import { HttpClientWrapper } from './http-client-wrapper.service';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PasswordManagementService {
  private httpWrapper = inject(HttpClientWrapper);

  submitUsernameForRecovery(username: string): Observable<any> {
    const formData = new HttpParams({ fromObject: { username } });

    return this.httpWrapper.post('/user/forgot-password', formData, {});
  }

  resetPassword(password: string, token: string): Observable<any> {
    const formData = new HttpParams({ fromObject: { password, token } });

    return this.httpWrapper.post(
      '/user/forgot-password/complete',
      formData,
      {},
    );
  }
}
